var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-automation-single" },
    [
      _c(
        "div",
        { staticClass: "row justify-content-between align-items-center mr-0" },
        [
          _c(
            "div",
            { staticClass: "col-lg-10 col-7" },
            [
              _vm.isDateOfBirth
                ? _c(
                    "h6",
                    { staticClass: "text-uppercase app-automation-title mb-0" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.triggerArguments.name) +
                          "\n      "
                      ),
                    ]
                  )
                : _c("i18n", {
                    staticClass: "text-uppercase app-automation-title mb-0",
                    attrs: {
                      tag: "h6",
                      path: "automations.applicationLevel." + _vm.trigger.key,
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.timeName
                          ? {
                              key: "time",
                              fn: function () {
                                return [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(_vm._s(_vm.timeName) + " "),
                                  ]),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  }),
              _vm._v(" "),
              _vm.isDateOfBirth
                ? _c("h6", { staticClass: "app-automation-subtitle mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "automations.applicationLevel.automaticallySendThisEmail"
                          )
                        ) +
                        "\n        " +
                        _vm._s(_vm.triggerArguments.name) +
                        "\n      "
                    ),
                  ])
                : _c("h6", { staticClass: "app-automation-subtitle mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "automations.applicationLevel." +
                              _vm.trigger.key +
                              "_description",
                            {
                              time: _vm.timeName,
                            }
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-lg-2 col-3 p-0 d-flex flex-row align-items-center justify-content-end",
            },
            [
              _c(
                "plan-tooltip",
                {
                  attrs: {
                    page: _vm.currentAccountPlanPage,
                    placement: "left",
                    disabled:
                      _vm.emptyActionArguments || _vm.automationIsActive,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            title: _vm.automationDisabledReason,
                            disabled: !_vm.emptyActionArguments,
                          },
                          expression:
                            "{\n            title: automationDisabledReason,\n            disabled: !emptyActionArguments\n          }",
                        },
                      ],
                      ref: "statusTooltip",
                      staticClass: "pretty pb-1 p-switch p-fill",
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: _vm.labelValue,
                          disabled: _vm.disabledAutomation,
                          type: "checkbox",
                        },
                        domProps: { checked: _vm.automationIsActive },
                        on: { change: _vm.handleToggleAutomationStatus },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state" }, [
                        _c(
                          "label",
                          {
                            staticClass: "hidden-text",
                            attrs: { for: _vm.labelValue },
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm ml-3",
                  class: _vm.detailsToggled ? "btn-primary" : "btn-white",
                  on: { click: _vm.handleSeeAutomationDetails },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.actions.viewDetails")) +
                      "\n        "
                  ),
                  _c("i", {
                    staticClass: "fa grey-text ml-2",
                    class: _vm.detailsToggled
                      ? "fa-caret-down"
                      : "fa-caret-right",
                  }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.detailsToggled
          ? _c(
              "div",
              { staticClass: "automation-details-dropdown" },
              [
                _c("application-automation-single-details", {
                  attrs: { automation: _vm.automation, time: _vm.time },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }